export const portalUrl = process.env.GATSBY_PORTAL_URL
export const apiUrl = process.env.GATSBY_API_URL
